module.exports = __webpack_public_path__ + "img/17.3bce0731.jpg";